<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-fall">
<h1>The Fall</h1>
<p style="text-indent: 00em;">I fell off my bike the other day</p>
<p style="text-indent: 00em;">It hurt a fair bit as there I lay</p>
<p style="text-indent: 00em;">Blood was running down my face from a cut above my eye</p>
<p style="text-indent: 00em;">I was only going at a slow pace, but still, there I had to lie</p>
<p style="text-indent: 00em;">While I got myself together again</p>
<p style="text-indent: 00em;">And hopped on my bike despite the pain</p>
<p style="text-indent: 00em;">I think damaged most was my pride</p>
<p style="text-indent: 00em;">As we headed home and completed the ride</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?7a105438